/* msd-buscador-barra.js
 *
 * Anade sugerencias de IMPRESORA a la barra de busqueda principal.
 *
 * Por que hace falta: la busqueda de Shopify NO indexa metacampos. Los ~9.700
 * modelos de impresora no son productos, solo datos, asi que su buscador nunca
 * los va a devolver por mucho que se configure. Esta capa va por encima.
 *
 * Convivencia con el tema: predictive-search.js reescribe el interior de
 * [data-predictive-search] en cada consulta. Nuestro bloque vive FUERA de ese
 * contenedor, asi que no se pisan. No se modifica ningun fichero nativo.
 *
 * Criterio de negocio (Gonzalo): si vendemos la impresora, la fila muestra la
 * ficha del catalogo Y el boton de consumibles: dos destinos, una sola fila.
 * Si no la vendemos, sale solo la sugerencia con el boton. Lo que se quiere
 * vender son consumibles, asi que el boton esta SIEMPRE.
 *
 * Si el indice no carga, no pasa nada: la barra sigue funcionando como antes.
 */
(function () {
  'use strict';

  var MAX = 6;            // filas nuestras; por encima tapa los productos
  var MIN = 2;            // caracteres antes de sugerir nada
  var DATOS = null, cargando = false;

  var caja = document.getElementById('msd-imp');
  if (!caja) return;
  var input = document.getElementById('msd-search-input');
  var ps = caja.closest('predictive-search');
  var form = caja.closest('form');
  var panel = form && form.querySelector('[data-predictive-search]');
  if (!input || !form) return;

  var URL_IDX = caja.getAttribute('data-src');

  function norm(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function clave(s) { return norm(s).replace(/[^a-z0-9]/g, ''); }

  function carga() {
    if (DATOS || cargando || !URL_IDX) return;
    cargando = true;
    fetch(URL_IDX)
      .then(function (r) { return r.json(); })
      .then(function (j) { DATOS = j; cargando = false; pinta(); })
      .catch(function () { cargando = false; });   // se queda como estaba
  }

  /* Busqueda por palabras sobre "marca modelo": escribir 'brother j4335' o
     'j4335dw' tiene que llegar al mismo sitio. Se puntua para que lo que
     EMPIEZA por lo escrito salga antes que lo que solo lo contiene. */
  function busca(q) {
    if (!DATOS) return [];
    var pals = norm(q).split(/\s+/).filter(Boolean);
    if (!pals.length) return [];
    var qk = clave(q);
    var out = [];
    for (var i = 0; i < DATOS.m.length; i++) {
      var f = DATOS.m[i];
      var marca = DATOS.marcas[f[0]];
      var texto = norm(marca + ' ' + f[1]);
      var tk = clave(marca + f[1]);
      var vale = true;
      for (var p = 0; p < pals.length; p++) {
        if (texto.indexOf(pals[p]) === -1) { vale = false; break; }
      }
      if (!vale && qk.length >= 4 && tk.indexOf(qk) !== -1) vale = true;
      if (!vale) continue;
      var punt = 0;
      if (clave(f[1]).indexOf(clave(pals[pals.length - 1])) === 0) punt -= 3;
      if (f[3] >= 0) punt -= 2;          // si la vendemos, arriba
      out.push([punt, f[1].length, f]);
      if (out.length > 400) break;
    }
    out.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });

    /* Una misma impresora puede estar dos veces en el indice con el nombre de
       familia delante: 'EcoTank ET-2850' y 'ET 2850' son la misma maquina, y
       salian como dos filas. Se quita la familia para comparar y gana la que
       tenga ficha de producto, que por el orden ya viene antes. */
    var vistas = {}, unicas = [];
    for (var k = 0; k < out.length && unicas.length < MAX; k++) {
      var g = out[k][2];
      var kk = g[0] + '|' + clave(f_familia(g[1]));
      if (vistas[kk]) continue;
      vistas[kk] = 1;
      unicas.push(g);
    }
    return unicas;
  }

  var FAMILIA = /^(ecotank pro|ecotank|expression photo hd|expression photo|expression|workforce pro|workforce|smart tank|laserjet pro|laserjet|officejet pro|officejet|deskjet|color laser|maxify|pixma|envy)\s+/i;

  function f_familia(m) {
    var s = (m || '').replace(FAMILIA, '');
    // si al quitar la familia no queda ningun numero, no era una familia:
    // se deja el nombre entero para no fundir modelos distintos
    return /\d/.test(s) ? s : m;
  }

  function enlaceConsumibles(f) {
    var marca = DATOS.marcas[f[0]];
    var u = '/collections/' + (DATOS.col[f[2]] || DATOS.col.t)
          + '?filter.p.m.custom.impresoras=' + encodeURIComponent(f[1]);
    if (marca && marca !== 'Otras') {
      u += '&filter.p.m.custom.marca_compatible=' + encodeURIComponent(marca);
    }
    return u + '&sort_by=price-ascending';
  }

  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;',
               '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fila(f) {
    var marca = DATOS.marcas[f[0]];
    var pr = f[3] >= 0 ? DATOS.prod[f[3]] : null;
    var h = '<li class="msd-imp__fila">';
    if (pr) {
      h += '<a class="msd-imp__prod" href="/products/' + esc(pr[0]) + '">'
         + (pr[2] ? '<img src="' + esc(pr[2]) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="msd-imp__ph"></span>')
         + '<span class="msd-imp__txt"><strong>' + esc(pr[1]) + '</strong>'
         + '<em>' + esc(marca + ' ' + f[1]) + (pr[3] ? ' &middot; en stock' : '') + '</em></span></a>';
    } else {
      h += '<span class="msd-imp__prod msd-imp__prod--solo">'
         + '<span class="msd-imp__ph"></span>'
         + '<span class="msd-imp__txt"><strong>' + esc(marca + ' ' + f[1]) + '</strong>'
         + '<em>tu impresora</em></span></span>';
    }
    h += '<a class="msd-imp__btn" href="' + esc(enlaceConsumibles(f)) + '">'
       + 'Consumibles compatibles</a></li>';
    return h;
  }

  function alto() {
    if (!panel) return;
    var h = caja.hidden ? 0 : caja.offsetHeight;
    panel.style.marginTop = h ? h + 'px' : '';
  }

  function oculta() {
    caja.hidden = true;
    caja.innerHTML = '';
    alto();
  }

  function pinta() {
    var q = (input.value || '').trim();
    if (q.length < MIN) { oculta(); return; }
    if (!DATOS) { carga(); return; }
    var r = busca(q);
    if (!r.length) { oculta(); return; }
    caja.innerHTML = '<p class="msd-imp__tit">Tu impresora</p><ul class="msd-imp__lista">'
                   + r.map(fila).join('') + '</ul>';
    caja.hidden = false;
    alto();
    /* Si Shopify no encuentra productos, el desplegable no se abre solo y
       nuestras sugerencias no se verian. Se abre aqui. */
    if (ps && !ps.hasAttribute('open')) {
      ps.setAttribute('open', true);
      input.setAttribute('aria-expanded', 'true');
    }
  }

  var t = null;
  input.addEventListener('input', function () {
    clearTimeout(t);
    t = setTimeout(pinta, 120);
    carga();
  });
  input.addEventListener('focus', carga);
  form.addEventListener('reset', function () { setTimeout(oculta, 0); });

  /* cuando el tema cierra el desplegable, cerramos con el */
  if (ps && window.MutationObserver) {
    new MutationObserver(function () {
      if (!ps.hasAttribute('open')) oculta();
    }).observe(ps, { attributes: true, attributeFilter: ['open'] });
  }
})();
